import React from "react";
import "../assets/scss/pagesScss/career.module.scss";

const Career = () => {
  return (
    <div className="career-container">
      <section className="benefits">
        <h2>Why you Should Join Our Awesome Team</h2>
        <p>
          We provide an environment where you can work on fulfilling projects
          and grow in your career. Join us and be part of something special.
        </p>
        <div className="benefit-list">
          <div className="benefit-item">
            <img src="/icons/teamwork.svg" alt="Team Work" />
            <h3>Team Work</h3>
            <p>Join a strong, dynamic team that helps you excel.</p>
          </div>
          <div className="benefit-item">
            <img src="/icons/security.svg" alt="Secured Future" />
            <h3>Secured Future</h3>
            <p>Grow in a career path that ensures stability and success.</p>
          </div>
          <div className="benefit-item">
            <img src="/icons/learning.svg" alt="Learning Opportunity" />
            <h3>Learning Opportunity</h3>
            <p>Stay ahead with our continuous training programs.</p>
          </div>
          <div className="benefit-item">
            <img src="/icons/skills.svg" alt="Upgrade Skills" />
            <h3>Upgrade Skills</h3>
            <p>Enhance your expertise with challenging projects.</p>
          </div>
        </div>
      </section>
      
      <section className="contact-form">
        <h2>Have Questions?</h2>
        <h3>Get in Touch!</h3>
        <form>
          <input type="text" placeholder="Name" required />
          <input type="email" placeholder="Email Address" required />
          <input type="text" placeholder="Phone" required />
          <select>
            <option>Position</option>
            <option>Developer</option>
            <option>Designer</option>
            <option>Marketing</option>
          </select>
          <label>
            <input type="checkbox" /> I agree that my data is collected and stored
          </label>
          <button type="submit">Get In Touch</button>
        </form>
        <div className="contact-info">
          <p>Address: 725 5th Street, Office 435</p>
          <p>Email: hiring@jobcare.com</p>
          <p>Phone: +1234 567 789</p>
        </div>
      </section>
    </div>
  );
};

export default Career;
